import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import UserInfo from './UserInfo';
import UserIntro from './UserIntro';
import UserProjects from './UserProjects';
import { useParams } from 'react-router-dom';
import useUser from '../useUser';

const UserProfile = () => {
 const { id } = useParams();
 const { data, configDispatch } = useUser(id);

 useEffect(() => {
  configDispatch({
   type: 'RESTORE',
   payload: { tem: true, isFluid: true, navbarPosition: 'top', disabledNavbarPosition: ['vertical', 'combo'] }
  });
 }, []);

 return (
  data && (
   <Row className="g-3">
    <Col lg={4} xl={3}>
     <div className="sticky-sidebar top-navbar-height">
      <UserInfo data={data} />
     </div>
    </Col>
    <Col lg={8} xl={9}>
     <UserIntro data={data} />
     <UserProjects />
    </Col>
   </Row>
  )
 );
};

export default UserProfile;
